import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { CalendarContainer } from './styles';
import { CalendarBar } from './CalendarBar';
import CupCalendarTabbar from '../../components/CupCalendarTabbar';
import DayTable from './DayTable';
import { getQuery } from '../../helpers';

class RugbyCalendar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobile: false,
      currentPhase: null,
      currentSubPhase: null,
    };
  }

  componentDidMount() {
    this.resizeCallback();
    const { sportId, competitionId, seasonId } = window.matchcenterPage;
    const queryObj = getQuery(document.location);
    let outFase = null;
    let outSubfase = null;
    if (queryObj && (queryObj.giornata || queryObj.fase)) {
      if (queryObj.giornata) {
        outFase = queryObj.giornata;
      } else if (queryObj.fase) {
        outFase = queryObj.fase;
        outSubfase = queryObj.subfase;
      }
    }
    this.props.actions.getRugbyTabbar(sportId, competitionId, seasonId, outFase, outSubfase);
    window.addEventListener('resize', this.resizeCallback);
  }

  componentWillReceiveProps(nextProps) {
    const queryObj = getQuery(document.location);
    let { currentPhase, currentSubPhase } = this.state;
    if (queryObj && (queryObj.giornata || queryObj.fase)) {
      if (queryObj.giornata) {
        currentPhase = 'regularSeason';
      } else if (queryObj.fase) {
        currentPhase = queryObj.fase;
        if (queryObj.subfase) {
          currentSubPhase = queryObj.subfase;
        }
      }
    } else {
      currentPhase = nextProps.cupTabbar.getIn(['lastPhase', 'label']);
      currentSubPhase = nextProps.cupTabbar.get('lastSubPhase');
    }
    this.setState({
      currentPhase, currentSubPhase,
    });
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeCallback);
  }

  resizeCallback = () => {
    this.setState({
      isMobile: window.innerWidth <= this.dynamicBreakPointWindow(process.env.REACT_APP_SITE),
    });
  };

  dynamicBreakPointWindow = (site) => {
    if (site === 'gazzetta') {
      return 1023;
    } else if (site === 'fcinter' || site === 'calcionapoli1926' || site === 'forzaroma') {
      return 980;
    } else if (site === 'corriere') {
      return 767;
    } else {
      return 1023;
    }
  };

  render() {
    const {
      actions, dictionary, calendar, cupTabbar,
    } = this.props;
    const { isMobile, currentPhase, currentSubPhase } = this.state;
    return (
      <CalendarContainer>
        {currentPhase !== 'regularSeason' &&
          <CupCalendarTabbar
            currentPhase={currentPhase}
            currentSubPhase={currentSubPhase}
            phases={cupTabbar.get('phases')}
            dictionary={dictionary}
            actions={actions}
            isMobile={isMobile}
            isCup
            isInnerMenu
            isRugby
          />
        }
        {calendar && calendar.get('currentDay') &&
          <CalendarBar
            dictionary={dictionary}
            actions={actions}
            currentDay={calendar.get('currentDay')}
            isMobile={isMobile}
          />
        }
        {calendar && calendar.get('games') && calendar.get('games').map((c, index) => (
          <DayTable
            matchDate={c.get('date')}
            matches={c.get('matches')}
            dictionary={dictionary}
            isMobile={isMobile}
            actions={actions}
            key={index}
          />
        ))
        }
      </CalendarContainer>
    );
  }
}

RugbyCalendar.propTypes = {
  dictionary: PropTypes.any,
  actions: PropTypes.any,
  calendar: PropTypes.any,
  cupTabbar: PropTypes.any,
};

export default RugbyCalendar;



// WEBPACK FOOTER //
// ./src/containers/RugbyCalendar/index.js